export function zoomOutByKm(lat, lng, km = 2) {
  const offset = km / 111.32; // convert km to degrees
  const latOffset = offset;
  const lngOffset = offset / Math.cos(lat * (Math.PI / 180)); // adjust for longitude based on latitude

  return {
    latitude_from: lat - latOffset,
    latitude_to: lat + latOffset,
    longitude_from: lng - lngOffset,
    longitude_to: lng + lngOffset,
  };
}

export function getDistanceBetweenPoints(lat1, lng1, lat2, lng2) {
  const R = 6371; // Radius of the Earth in km
  const dLat = (lat2 - lat1) * (Math.PI / 180);
  const dLng = (lng2 - lng1) * (Math.PI / 180);

  const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(lat1 * (Math.PI / 180)) * Math.cos(lat2 * (Math.PI / 180)) *
            Math.sin(dLng / 2) * Math.sin(dLng / 2);

  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

  return R * c; // Distance in km
}
